// World dimensions — fixed for multiplayer; clients render a viewport into this.
export const WORLD_WIDTH = 3000;
export const WORLD_HEIGHT = 2000;

// Simulation rates
export const TICK_HZ = 60;
export const TICK_MS = 1000 / TICK_HZ;
export const SNAPSHOT_HZ = 30;
export const SNAPSHOT_EVERY_TICKS = Math.round(TICK_HZ / SNAPSHOT_HZ);

// World presentation / wall physics
export const WORLD_BORDER_LINE_WIDTH = 4;
export const SHIP_WALL_RESTITUTION = 0.72;
export const SHIP_WALL_TANGENTIAL_FRICTION = 0.94;
export const SHIP_WALL_SPIN_COUPLING = 0.55;
export const ASTEROID_WALL_RESTITUTION = 0.9;
export const ASTEROID_WALL_TANGENTIAL_FRICTION = 0.985;
export const ASTEROID_WALL_SPIN_COUPLING = 0.04;

// Ship physics
export const SHIP_RADIUS = 20;
export const SHIP_NOSE_OFFSET = 15;
export const SHIP_ROTATION_THRUST = 0.38; // angular velocity delta per tick
export const SHIP_ROTATION_BRAKE_THRUST = SHIP_ROTATION_THRUST;
export const SHIP_ROTATION_INERTIA = 0.934;
// Hard ceiling on angularVelocity. Player input naturally settles at ~5.8 deg/tick due to inertia,
// so the headroom above that is reserved for collision impulses (shield bumps from asteroids).
export const SHIP_MAX_ROTATION_SPEED = 30;
export const SHIP_THRUST = 0.36;        // slightly stronger thrust response
export const SHIP_INERTIA = 0.9866;     // matched to keep roughly the same top speed
export const SHIP_BRAKE_INERTIA = 0.964; // extra velocity damping while brake is held
export const SHIP_FIRE_COOLDOWN_MS = 150;          // server token refill interval
export const SHIP_HOLD_FIRE_INTERVAL_MS = 300;     // client throttle while fire is held
export const SHIP_BURST_TOKENS_MAX = 13;           // refills 1 per SHIP_FIRE_COOLDOWN_MS
export const SHIP_RESPAWN_DELAY_MS = 3000;

// Lobby bell
export const LOBBY_BELL_DURATION = 300;

// Room DO: periodic alarm reaps ghost rooms (0 players in memory, row still in D1). Teardown is
// otherwise driven by WebSocket close → removePlayer → onEmpty → same reap path.
export const ROOM_CONNECTION_SWEEP_MS = 60000;

// Bullet
export const BULLET_RADIUS = 2;
export const BULLET_SPEED = 10;          // pixels per tick (was posDelta/2 from rotation offset 20)
export const BULLET_LIFETIME_TICKS = 42; // TTL at BULLET_SPEED px/tick

// Asteroid
export const ASTEROID_START_SIZE = 80;
export const ASTEROID_MIN_SPLIT_RADIUS = 10;
export const ASTEROID_VERTEX_COUNT = 8;
export const ASTEROID_INITIAL_COUNT = 3;

// Balanced scoring
export const CTF_KILL_BONUS = 1;
export const CTF_CAPTURE_BONUS = 10;
export const CTF_FLAG_PICKUP_BONUS = 2;
export const DEATHMATCH_KILL_BONUS = 1;
export const ASTEROID_BONUS_LARGE = 1;
export const ASTEROID_BONUS_MEDIUM = 2;
export const ASTEROID_BONUS_SMALL = 3;
export const ASTEROID_BONUS_TINY = 5;

// Shields (lobby toggle: "shieldsMode")
export const SHIELD_DEFAULT_COUNT = 5;
export const SHIELD_THICKNESS = 6;                  // extra hit radius (px) when shields up

// Mass constants for shield collision impulses (tunable)
export const SHIP_MASS = 1.0;
export const BULLET_MASS = 0.04;
export const ASTEROID_DENSITY = 0.0008;             // mass = π r² × density

// Shield impulse coefficients (tunable; see physics.js for derivation)
export const SHIELD_BULLET_VELOCITY_TRANSFER = 0.85;
export const SHIELD_BULLET_SPIN_GAIN = 0.4;          // glancing bullet → ~60° integrated rotation
export const SHIELD_ASTEROID_RESTITUTION = 0.55;
export const SHIELD_ASTEROID_VELOCITY_TRANSFER = 0.9;
export const SHIELD_ASTEROID_SPIN_GAIN = 1.0;        // big rock → spin saturates near cap

// Capture the Flag
export const CTF_ROUND_DURATION_MS = 300000;
export const CTF_BASE_SIZE = SHIP_RADIUS * 4;
export const CTF_FLAG_RADIUS = 26;
export const CTF_FLAG_SPAWN_WIDTH = SHIP_RADIUS * 6;
export const CTF_FLAG_SPAWN_HEIGHT = SHIP_RADIUS * 6;
export const CTF_RESPAWN_OFFSET = SHIP_RADIUS * 6;
export const CTF_TEAM_YELLOW = { id: 'yellow', name: 'Yellow', color: '#ffe066' };
export const CTF_TEAM_CYAN = { id: 'cyan', name: 'Cyan', color: '#63e6ff' };
export const CTF_TEAMS = [CTF_TEAM_YELLOW, CTF_TEAM_CYAN];

// Player slot colors (P1..P4)
export const PLAYER_COLORS = ['#ffffff', '#63e6ff', '#ffe066', '#ff7af5'];
export const MAX_PLAYERS = 4;
